import { configureStore } from '@reduxjs/toolkit';

import academyDataSlice from './academy-slice';
import userDataActions from './user-slice';
import notificationsDataActions from './notifications-slice';
import searchDataActions from './search-slice';
import recoverAccountDataActions from './recoverAccount-slice';
import courseDataActions from './course-slice';
import lessonDataActions from './lesson-slice';

const store = configureStore({
  reducer: {
    academyInfo: academyDataSlice.reducer,
    userInfo: userDataActions.reducer,
    notifications: notificationsDataActions.reducer,
    searchInfo: searchDataActions.reducer,
    recoverAccountInfo: recoverAccountDataActions.reducer,
    courseInfo: courseDataActions.reducer,
    lessonInfo: lessonDataActions.reducer
  }
});

export default store;
